export default "__VITE_ASSET__Sx5qt$Q7__"